import { render, staticRenderFns } from "./msGridViewer.vue?vue&type=template&id=8bf1eb2a&scoped=true"
import script from "./msGridViewer.vue?vue&type=script&lang=js"
export * from "./msGridViewer.vue?vue&type=script&lang=js"
import style0 from "./msGridViewer.vue?vue&type=style&index=0&id=8bf1eb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf1eb2a",
  null
  
)

export default component.exports